import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { useSummaryChartsDataContext } from './useSummaryChartsDataContext';

const useAnnualPercentageServices = () => {
    const { chartData } = useSummaryChartsDataContext();


    const categories = chartData.annualPercentageServices.map(
        (item) => item.description
    );

    const subtitles = ['Identificados', 'Nao Identificados'];

    const totalPerCategory = categories.map((category) => {
        const found = chartData.annualPercentageServices
            .filter((counter) => counter.description === category)
            .reduce((acc, curr) => {
                const total =
                    Number(curr.noIdentified) +
                    Number(curr.identified) 
                return acc + total;
            }, 0);

        return found ? Number(found) : 0;
    });

    const series = subtitles.map((subtitle) => {
        const data = categories.map((category, index) => {
            if (totalPerCategory[index] === 0) {
                return 0;
            }

            const found = chartData.annualPercentageServices.find(
                (counter) => counter.description === category
            );

            let value = 0;

            switch (subtitle) {
                case 'Identificados':
                    value = found.noIdentified;
                    break;
                case 'Nao Identificados':
                    value = found.identified;
                    break;
                default:
                    value = 0;
                    break;
            }

            return found
                ? ((Number(value) / totalPerCategory[index]) * 100).toFixed(2)
                : 0;
        });

        return {
            name: subtitle,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true
                }
            },
            yaxis: {
                max: 100,
                labels: {
                    formatter: (val) => `${val}`
                }
            },
            xaxis: {
                categories: categories || [],
                labels: {
                    formatter: (val) => `${val}%`
                }
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#333'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useAnnualPercentageServices;
